import {
  creativeType,
  // advEntity,
  offerType,
  offerCategory,
  creativeCategory,
  rejectReason,
  materialGrading,
  priorityOptions,
  remarkOptions,
  auditResultOptions,
} from '../review.js'
// import { advGradeList } from '@/common/demand'
export const FormItemMixin = {
  computed: {
    formItemList() {
      return {
        offer_field: {
          type: 'select',
          prop: 'offer_field',
          class: 'offer-selector',
          params: {
            placeholder: 'Offer field',
            options: offerCategory,
          },
        },
        offer_field_value: {
          type: 'input',
          subtype: 'autocomplete',
          prop: 'offer_field_value',
          class: 'offer-input',
          params: {
            clearable: true,
            placeholder:
              this.query.offer_field === 'uuid' ? 'Offer uuid' : 'Ofter name',
            triggerOnFocus: false,
            fetchSuggestions: (querySearch, cb) => {
              this.getSuggestList(
                {
                  field: 'offer_' + this.query.offer_field,
                  keyword: querySearch,
                  status: this.query.status,
                },
                cb,
              )
            },
          },
        },
        campaign_name: {
          type: 'input',
          subtype: 'autocomplete',
          prop: 'campaign_name',
          params: {
            clearable: true,
            placeholder: 'Campaign Name',
            triggerOnFocus: false,
            fetchSuggestions: (querySearch, cb) => {
              this.getSuggestList(
                {
                  field: 'campaign_name',
                  keyword: querySearch,
                  status: this.query.status,
                },
                cb,
              )
            },
          },
        },
        offer_type: {
          type: 'select',
          prop: 'offer_type',
          params: {
            clearable: true,
            placeholder: 'Offer Type',
            options: offerType,
          },
        },
        adv_name: {
          type: 'input',
          subtype: 'autocomplete',
          prop: 'adv_name',
          params: {
            clearable: true,
            placeholder: 'Adv Name',
            triggerOnFocus: false,
            fetchSuggestions: (querySearch, cb) => {
              this.getSuggestList(
                {
                  field: 'adv_name',
                  keyword: querySearch,
                  status: this.query.status,
                },
                cb,
              )
            },
          },
        },
        creative_field: {
          type: 'select',
          prop: 'creative_field',
          class: 'creative-selector',
          params: {
            placeholder: 'Creative field',
            options: creativeCategory,
          },
        },
        creative_id: {
          visible: this.query.creative_field === 'id',
          type: 'input',
          prop: 'creative_id',
          class: 'creative-input',
          params: {
            clearable: true,
            placeholder: 'Creative ID',
          },
        },
        creative_name: {
          visible: this.query.creative_field === 'name',
          type: 'input',
          subtype: 'autocomplete',
          prop: 'creative_name',
          class: 'creative-input',
          params: {
            clearable: true,
            placeholder: 'Creative Name',
            triggerOnFocus: false,
            fetchSuggestions: (querySearch, cb) => {
              this.getSuggestList(
                {
                  field: 'creative_name',
                  keyword: querySearch,
                  status: this.query.status,
                },
                cb,
              )
            },
          },
        },
        review_id: {
          visible: this.query.creative_field === 'review_id',
          type: 'input',
          prop: 'id',
          class: 'creative-input',
          params: {
            clearable: true,
            placeholder: 'ID',
          },
        },
        app_name: {
          type: 'input',
          prop: 'app_name',
          params: {
            clearable: true,
            placeholder: 'App name',
          },
        },
        package_name: {
          type: 'input',
          prop: 'package_name',
          params: {
            clearable: true,
            placeholder: 'Package name',
          },
        },
        creative_type: {
          type: 'select',
          prop: 'creative_type',
          params: {
            clearable: true,
            placeholder: 'Creative type',
            options: creativeType,
          },
        },
        search_time: {
          type: 'select',
          prop: 'search_time',
          class: 'creative-selector',
          params: {
            placeholder: 'Time Field',
            options: [
              {
                label: 'Upload Time',
                value: 'upload_time',
              },
              {
                label: 'Update Time',
                value: 'update_time',
              },
            ],
          },
        },
        time: {
          type: 'date-picker',
          prop: 'time',
          class: 'creative-input m-date-range',
          subtype: 'datetimerange',
          params: {
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
            isRange: true,
            clearable: true,
            placeholder: 'select time',
            handleBlur: () => {
              self.selectDate = ''
            },
            pickerOptions: {
              /* eslint-disable no-mixed-operators */
              disabledDate(time) {
                if (self.selectDate) {
                  const days = 6 * 24 * 3600 * 1000

                  const curDate = new Date().getTime()
                  const years = curDate - 360 * 24 * 3600 * 1000

                  return (
                    time.getTime() < self.selectDate ||
                    time.getTime() > self.selectDate + days ||
                    time.getTime() < years
                  )
                }
                return false
              },
              onPick: ({ maxDate, minDate }) => {
                self.selectDate = minDate.getTime()
                if (maxDate) {
                  self.selectDate = ''
                }
              },
            },
          },
        },
        // adv_entity: {
        //   type: 'select',
        //   prop: 'adv_entity',
        //   params: {
        //     clearable: true,
        //     placeholder: 'Entity',
        //     options: advEntity,
        //   },
        // },
        operator: {
          visible: Number(this.query.status) !== 1,
          type: 'input',
          prop: 'operator',
          params: {
            clearable: true,
            placeholder: 'Operator',
          },
        },
        draft_operator: {
          visible: true,
          type: 'input',
          prop: 'draft_operator',
          params: {
            clearable: true,
            placeholder: 'Draft Operator',
          },
        },
        pm: {
          type: 'input',
          subtype: 'autocomplete',
          prop: 'pm',
          params: {
            clearable: true,
            placeholder: 'PM',
            triggerOnFocus: false,
            fetchSuggestions: (querySearch, cb) => {
              this.getSuggestList(
                {
                  field: 'pm',
                  keyword: querySearch,
                },
                cb,
              )
            },
          },
        },
        // pm_teams: {
        //   type: 'business',
        //   subtype: 'pm-teams-selector',
        //   prop: 'pm_teams',
        //   params: {
        //     placeholder: 'PM Teams',
        //     multiple: true,
        //   },
        // },
        reason_ids: {
          visible: this.tabs.current === 'Audit Result（审核结果）',
          type: 'select',
          prop: 'reason_ids',
          params: {
            placeholder: 'reject reason',
            clearable: true,
            multiple: true,
            filterable: true,
            'collapse-tags': true,
            options: rejectReason,
          },
        },
        // from_platform: {
        //   type: 'select',
        //   prop: 'from_platform',
        //   params: {
        //     clearable: true,
        //     placeholder: 'Create from',
        //     options: [
        //       {
        //         label: 'adv',
        //         value: 'adv',
        //       },
        //       {
        //         label: 'playturbo',
        //         value: 'playturbo',
        //       },
        //       {
        //         label: 'self-made',
        //         value: 'self-made',
        //       },
        //     ],
        //   },
        // },
        // grade: {
        //   type: 'select',
        //   prop: 'adv_grade',
        //   params: {
        //     clearable: true,
        //     placeholder: 'Grade',
        //     multiple: true,
        //     options: advGradeList,
        //   },
        // },
        platform: {
          type: 'select',
          prop: 'platform',
          params: {
            clearable: true,
            placeholder: 'Platform',
            options: this.platformOptions,
          },
        },
        // offer_geo: {
        //   prop: 'offer_geo',
        //   type: 'select',
        //   params: {
        //     filterable: true,
        //     clearable: true,
        //     options: this.countryList,
        //     placeholder: '请选择offer_geo'
        //   }
        // },
        // creative_geo: {
        //   prop: 'creative_geo',
        //   type: 'select',
        //   params: {
        //     filterable: true,
        //     clearable: true,
        //     options: this.countryList,
        //     placeholder: '请选择creative_geo'
        //   }
        // },
        re_review: {
          visible: this.tabs.current === 'Audit Result（审核结果）',
          prop: 're_review',
          type: 'select',
          params: {
            filterable: true,
            clearable: true,
            options: [
              {
                label: '是',
                value: 1,
              },
              {
                label: '否',
                value: 2,
              },
            ],
            placeholder: '是否巡审',
          },
        },
        review: {
          visible: this.tabs.current === 'Audit Result（审核结果）',
          prop: 'review',
          type: 'select',
          params: {
            filterable: true,
            clearable: true,
            options: [
              {
                label: '是',
                value: 1,
              },
              {
                label: '否',
                value: 2,
              },
            ],
            placeholder: '是否经过复审',
          },
        },
        audit_result: {
          visible: this.tabs.current === 'Audit Result（审核结果）',
          prop: 'audit_result',
          type: 'select',
          params: {
            filterable: true,
            clearable: true,
            placeholder: 'audit result',
            options: auditResultOptions,
          },
        },
        remark: {
          type: 'input',
          prop: 'remark',
          params: {
            clearable: true,
            placeholder: 'Notes',
          },
        },
        material_gradings: {
          prop: 'material_gradings',
          type: 'select',
          params: {
            clearable: true,
            multiple: true,
            filterable: true,
            'collapse-tags': true,
            placeholder: '素材分级',
            options: materialGrading,
          },
        },
        audit_remarks: {
          prop: 'audit_remarks',
          type: 'select',
          params: {
            clearable: true,
            multiple: true,
            filterable: true,
            'collapse-tags': true,
            placeholder: '审核备注',
            options: remarkOptions,
          },
        },
        priority: {
          visible: this.tabs.current === 'Re-Review（巡审）',
          prop: 'priority',
          type: 'select',
          params: {
            clearable: true,
            placeholder: '优先级',
            options: priorityOptions,
          },
        },
        uniq_adv_pkg_md5: {
          type: 'select',
          prop: 'uniq_adv_pkg_md5',
          params: {
            clearable: true,
            placeholder: 'adv*pkg*md5去重',
            options: [
              {
                label: '是',
                value: 1,
              },
              {
                label: '否',
                value: 2,
              },
            ],
          },
        },
        page_size: {
          type: 'select',
          prop: 'page_size',
          params: {
            options: [15, 20, 50, 100, 200, 300, 400].map((item) => ({
              value: item,
              label: item + '条/页',
            })),
          },
        },
      }
    },
    offerFormItemList() {
      return {
        creative_name: {
          type: 'input',
          prop: 'creative_name',
          params: {
            clearable: true,
            placeholder: '请输入素材名称',
          },
        },
      }
    },
  },
}
